
import { defineComponent, onMounted, ref } from "vue";
import { getAdvisoryDetails, getBankAccountNo, getAwardingDetails_API } from "@/api/dashboard";
import { ecShopAdvisoryVisibility } from "@/api/common";
import Swal from "sweetalert2/dist/sweetalert2.min.js";


export default defineComponent({
  name: "ecshopadvisory",
  components: {
  },
  data() {
    return { 
      pt : "",
      ecp_welcome_data: {},
      usid : "",
      unilevelMaintenancePromptMessage : "",
      unilevelMaintenancePromptMessage1 : "",
      unilevelMaintenancePromptMessage2 : "",
      isShowPMAWarning : false,
      isEnabledECCSRNotification : false,
      csrMessage : "",
      ccode : -1,
      windowHeight: window.innerHeight,
      windowWidth: window.innerWidth,
      nigeriaAIMGLOBAL_HQ_WARNING_ImgUrl : "",
      bankAccountNo : "",
      isShowBDOMastercardAdvisory : false,
      isDMPayView : false,
      ecShopAdvisoryVisibility,
      isShowHoodiePage : false,
      awarding_details : {},
    }
  },
  mounted(){
    this.pt = String(localStorage.getItem("pt"));
    this.usid = String(localStorage.getItem("ec_current_usid"));
    this.getDashboardECPWelcomeData();
    this.getAwardingDetails();
    //this.getUserCcode();
    //this.getBankAccountNumber();
    this.checkIfDMPayView();
    this.onResize();
    this.ccode = Number(localStorage.getItem("ccode"));

    let currLocation = String(window.location).split("/#/");
    let currView = "";
    if(currLocation.length > 1){
      currView = currLocation[1];
    }
    this.ecShopAdvisoryVisibility = ecShopAdvisoryVisibility;


  },
  methods : {
    async getDashboardECPWelcomeData(){
      var self = this;
      const response = await getAdvisoryDetails();
      
      self.ecp_welcome_data = response.data;
      self.unilevelMaintenancePromptMessage = response.data.unilevelMaintenancePromptMessage;

      this.isEnabledECCSRNotification = response.data.isEnabledECCSRNotification;
      this.csrMessage = response.data.orderid;
      
      self.unilevelMaintenancePromptMessage1 = self.unilevelMaintenancePromptMessage.split("complete your maintenance NOW")[0];
      self.unilevelMaintenancePromptMessage2 = self.unilevelMaintenancePromptMessage.split("complete your maintenance NOW")[1];

      if(self.unilevelMaintenancePromptMessage.includes("To continue")
       && response.data.is10DaysLeftForPMA){
        self.isShowPMAWarning = true;
      } else {
        self.isShowPMAWarning = false;
      }

      self.isShowBDOMastercardAdvisory = response.data.isShowBDOMastercardAdvisory;

      self.isShowHoodiePage = response.data.isShowHoodiePage;
    },
    async getUserCcode() {
      this.ccode = Number(localStorage.getItem("ccode"));
    },
    async checkIfDMPayView(){
      this.ccode = Number(localStorage.getItem("isDMPayView"));
    },
    async getBankAccountNumber() {
      const response = await getBankAccountNo();
        if(response.data !== undefined ) {
          this.bankAccountNo = response.data.bankAccountNo;
        }
    },

    async getAwardingDetails() {
      const response = await getAwardingDetails_API();
      if(response.data.awarding_barcode[0] !== undefined ) {
        this.awarding_details = response.data.awarding_barcode[0];
      }
    },
    onResize() {
      //this.windowHeight = window.innerHeight;
      this.windowWidth = window.innerWidth;
      if(this.windowWidth <= 450){
        this.nigeriaAIMGLOBAL_HQ_WARNING_ImgUrl = "https://images.empoweredconsumerism-static-files.com/ecp/AIMGLOBAL_HQ_DOT_COM_NIGERIA_MOBILE.jpg";
      } else {
        this.nigeriaAIMGLOBAL_HQ_WARNING_ImgUrl = "https://images.empoweredconsumerism-static-files.com/ecp/AIMGLOBAL_HQ_DOT_COM_NIGERIA_PC.jpg";
      }
    }
  },
  setup() {
    const tabIndex = ref(0);

    onMounted(() => {
      // set the tab from previous
    });
    
  }
});
